import { addResponseInterceptor, configureApiV2Client } from '@helios/frontend-api-v2-client';
import { getImpersonatedUserId, getToken } from '@helios/frontend-auth';
import React, { ReactNode, useMemo } from 'react';

import { PlatformConfig } from '../../../config';
import { handleAchievementPolling } from '../../../utils/achievementPolling';

interface Props {
  children: ReactNode;
}

const ApiV2ClientProvider: React.FC<Props> = ({ children }) => {
  useMemo(() => {
    configureApiV2Client({
      // Native and production web builds use the absolute API host. Native has no same-origin server;
      // production web builds may be served without an infra proxy (e.g. PR preview on Cloud Run).
      // Local dev leaves this empty so the Vite dev-server proxy handles routing.
      baseUrl: PlatformConfig.isNative || PlatformConfig.isProductionBuild ? PlatformConfig.baseApiUrl : '',
      getToken,
      getImpersonatedUserId,
    });
    addResponseInterceptor(handleAchievementPolling);
  }, []);

  return <>{children}</>;
};

export default ApiV2ClientProvider;
